
import React from 'react';

import Menu from './Menu';
import Slider from './Slider';
import About from './About';
import Buystep from './Buystep';
import Buysellprocess from './Buysellprocess';
import Chart from './Chart';
import Price from './Price';
import Footer from './Footer';

import './custom.css';

const Home = () => {
  return (
    <>
      <Menu />
      <Slider />
      <About />
      <Price />
      <Chart />
      <Buysellprocess />
      <Buystep />
      <Footer />
    </>
  );
};

export default Home;